/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_ErrorsInputs */

const en_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errors`)
};

const fr_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreurs`)
};

const de_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const it_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errori`)
};

const ru_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибки`)
};

const es_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errores`)
};

const zh_cn2_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const ja_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const hi_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटियाँ`)
};

const pt_pt2_options_quicktools_errors = /** @type {(inputs: Options_Quicktools_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erros`)
};

/**
* | output |
* | --- |
* | "Errors" |
*
* @param {Options_Quicktools_ErrorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_errors = /** @type {((inputs?: Options_Quicktools_ErrorsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_ErrorsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_errors(inputs)
	if (locale === "de") return de_options_quicktools_errors(inputs)
	if (locale === "it") return it_options_quicktools_errors(inputs)
	if (locale === "ru") return ru_options_quicktools_errors(inputs)
	if (locale === "es") return es_options_quicktools_errors(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_errors(inputs)
	if (locale === "ja") return ja_options_quicktools_errors(inputs)
	if (locale === "hi") return hi_options_quicktools_errors(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_errors(inputs)
	return en_options_quicktools_errors(inputs)
});